import { render, staticRenderFns } from "./SeatTab.vue?vue&type=template&id=a32f8b6a&scoped=true"
import script from "./SeatTab.vue?vue&type=script&lang=js"
export * from "./SeatTab.vue?vue&type=script&lang=js"
import style0 from "./SeatTab.vue?vue&type=style&index=0&id=a32f8b6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32f8b6a",
  null
  
)

export default component.exports